<!-- 人才招聘 -->
<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <!-- 头部 -->
        <div class="header_container">
          <span class="header_title">人才招聘</span>
          <span class="header_dec">我们正在招聘以下岗位：</span>
        </div>
        <!-- 内容 -->
        <div class="content_container">
          <div class="content_container1">
            <div class="item_contain" v-for="item in items">
              <div class="no_bg">
                <span class="item_no">{{item.index+1}}·</span>
              </div>
              <span class="item_tittle">{{item.title}}</span>
              <span class="item_content">{{item.dec}}</span>
            </div>
          </div>
          <span class="mailbox">欢迎投递简历，和我们一起快乐地工作！<br />请将简历发送至：<span style="color:#F5A623;">hr@everglamming.com</span>
            请在邮件标题注明所投职位。</span>
          <!-- 分割线 -->
          <div class="line"></div>
        </div>
      </div>
    </div>

    <div class="phone_container">
      <div class="phone_body_container">
        <!-- 头部 -->
        <div class="phone_header_container">
          <span class="phone_header_title">人才招聘</span>
          <span class="phone_header_dec">我们正在招聘以下岗位：</span>
        </div>
        <!-- 内容 -->
        <div class="phone_content_container">
          <div class="phone_indicators_container">
            <div class="phone_indicator" :class="{'is-active':index === indicatorIndex}" v-for="(item,index) in items"></div>
          </div>
          <swipe class="phone_content_container1" :style="autoHeight" :defaultIndex="0" :auto="0" :showIndicators="false" @change="onIndicatorChange">
            <swipe-item v-for="(item,index) in items" key="index">
              <div class="phone_item_contain" ref="contentBox">
                <div class="phone_no_bg">
                  <span class="phone_item_no">{{item.index+1}}·</span>
                </div>
                <span class="phone_item_tittle">{{item.title}}</span>
                <span class="phone_item_content">{{item.dec}}</span>
              </div>
            </swipe-item>
          </swipe>
          <span class="phone_mailbox">欢迎投递简历，和我们一起快乐地工作！<br />请将简历发送至：<br /><span
              style="color:#F5A623;">hr@everglamming.com</span>
            <br />请在邮件标题注明所投职位。</span>
          <!-- 分割线 -->
          <div class="phone_line"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Swipe from './custom/swipe.vue';
  import SwipeItem from './custom/swipe-item.vue';
  export default {
    name: 'talentRecruitment',
    data() {
      return {
        indicatorIndex:0,
        autoHeight:{
                  height: '100px'
                },
        items: [{
            title: '文案',
            dec: "工作内容：\n为平台公众号原创文章\n\n岗位要求：\n1、热爱传统文化；\n2、对码字得心应手；\n3、对读者充满爱与责任感。",
            index: 0
          },
          {
            title: '漫画师',
            dec: '工作内容：\n1、负责公司旗下产品的视觉漫画创作，微博、微信、百家号、头条号等新媒体渠道输出原创系列漫画，获流；\n2、根据项目需求，可独立构思，完成传统文化相关漫画样式的设计，人物形象的设计等。\n\n岗位要求：\n1、对中国传统文化感兴趣优先；\n2、扎实的漫画功底，美术、插画、动漫等美术相关专业，应届生也可；\n3、具有图像化思考的能力，原创能力强。能独立完成画面及人物角色创作，有过成熟的漫画作品；\n4、有责任心及较强的执行力，具有良好的沟通能力和团队协作意识；\n5、快速学习消化知识的能力；\n6、熟练使用绘图设计工具及软件，如数位板、PS、AI等。',
            index: 1
          },
        ],
      };
    },
    components: {
      swipe: Swipe,
      swipeItem: SwipeItem
    },
    mounted() {
      let dom = this.$refs.contentBox;
      this.autoHeight.height = dom[0].clientHeight+'px';
    },
    methods:{
      onIndicatorChange(newIndex, oldIndex) {
        this.indicatorIndex = newIndex;
        let dom = this.$refs.contentBox;
        this.autoHeight.height = dom[newIndex].clientHeight+'px';
      },
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: ht;
    src: url("../assets/font/HT.otf");
  }

  .web_container {
    width: 100%;
  }

  .body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_container {
    background-size: 100%;
    width: 100%;
    height: 25vw;
    background-image: url('../assets/home/bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_title {
    font-family: ht;
    font-size: 2.5vw;
    color: #000000;
    margin-top: 15.989583vw;
  }

  .header_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 1.25vw;
  }

  .content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content_container1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .item_contain {
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 31.25vw;
    margin-top: 2.239583vw;
    background-image: url('../assets/talent_recruitment/bg_content.png');
    background-repeat: no-repeat;
  }

  .no_bg {
    background-size: 100%;
    height: 2.8125vw;
    width: 3.125vw;
    align-self: flex-end;
    margin-top: -1.0vw;
    background-image: url(../assets/business_cooperation/bg_number.png);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .item_no {
    font-family: ht;
    font-size: 2.083333vw;
    color: #FFFFFF;
  }

  .item_tittle {
    font-family: ht;
    font-size: 1.25vw;
    color: #000000;
    margin-left: 1.666666vw;
    /* margin-top:2.604166vw; */
  }

  .item_content {
    font-family: 'PingFang SC';
    font-size: 1.041666vw;
    color: #4E4D4D;
    white-space: pre-wrap;
    line-height: 2.5vw;
    margin-top: 0.729166vw;
    margin-left: 1.666666vw;
    margin-right: 1.666666vw;
    margin-bottom: 2.604166vw;
  }

  .mailbox {
    font-family: ht;
    font-size: 1.25vw;
    color: #000000;
    margin-top: 3.333333vw;
    text-align: center;
    line-height: 1.666666vw;
  }

  .line {
    height: 0.052083vw;
    width: 52.083333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 4.166666vw;
    margin-bottom: 4.166666vw;
  }

  .phone_container {
    width: 100%;
  }

  .phone_body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_container {
    background-size: 100%;
    width: 100%;
    height: 78.933333vw;
    background-image: url('../assets/home/phone_bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_title {
    font-family: ht;
    font-size: 6.4vw;
    color: #000000;
    margin-top: 38.933333vw;
  }

  .phone_header_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 2.133333vw;
  }

  .phone_content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_indicators_container{
    display:flex;
  }

  .phone_indicator{
    width: 2.133333vw;
    height: 2.133333vw;
    display: inline-block;
    border-radius: 100%;
    background: #979797;
    margin: 0 1.6vw;
    opacity:0.15;
  }

  .phone_indicator.is-active{
    width: 4.266666vw;
    height: 2.133333vw;
    border-radius: 1.066666vw;
    background: #979797;
    opacity:0.3;
  }

  .phone_content_container1 {
     /* height:154.666666vw; */
     width:89.333333vw;
  }

  .phone_item_contain {
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top:1.0vw;
    width: 89.333333vw;
    background-image: url('../assets/talent_recruitment/phone_bg_content.png');
    background-repeat: repeat;
    margin-bottom:8.533333vw;
  }

  .phone_no_bg {
    background-size: 100%;
    height: 9.333333vw;
    width: 10.666666vw;
    align-self: flex-end;
    margin-top: -1.0vw;
    background-image: url(../assets/talent_recruitment/phone_bg_no.png);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .phone_item_no {
    font-family: ht;
    font-size: 5.333333vw;
    color: #FFFFFF;
  }

  .phone_item_tittle {
    font-family: ht;
    font-size: 5.333333vw;
    color: #000000;
    margin-left: 4.266666vw;
    /* margin-top:2.604166vw; */
  }

  .phone_item_content {
    font-family: 'PingFang SC';
    font-size: 3.733333vw;
    color: #4E4D4D;
    white-space: pre-wrap;
    line-height: 6.4vw;
    margin-top: 1.066666vw;
    margin-left: 4.266666vw;
    margin-right: 4.266666vw;
    margin-bottom: 6.133333vw;
  }

  .phone_mailbox {
    font-family: ht;
    font-size: 4.266666vw;
    color: #000000;
    margin-top: 12.8vw;
    text-align: center;
    line-height: 8.533333vw;
  }

  .phone_line {
    height: 0.266666vw;
    width: 89.333333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 17.066666vw;
    margin-bottom: 8.266666vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/TalentRecruitment.vue